import { startSlider } from './config.js';

const MOBILE_BREAKPOINT = '(max-width: 600px)';

const createSliderOptions = (section) => ({
    loop: false,
    rewind: false,
    speed: 650,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 20,
    watchOverflow: true,
    grabCursor: true,
    navigation: {
        prevEl: section?.querySelector('[data-advantages-prev]'),
        nextEl: section?.querySelector('[data-advantages-next]'),
    },
    autoplay: false,
    keyboard: {
        enabled: true,
        onlyInViewport: true,
    },
});

const initSlider = (slider) => {
    if (!slider.querySelector('.swiper-slide')) {
        return;
    }

    return startSlider(slider, createSliderOptions(slider.closest('.slider-section')));
};

const destroySlider = (slider) => {
    slider.swiper?.destroy(true, true);
    slider.querySelectorAll('[data-slider-loop-clone="true"]').forEach((clone) => clone.remove());
    slider.querySelector('.swiper-wrapper')?.removeAttribute('data-slider-loop-prepared');
};

const syncSliders = (sliders, isMobile) => {
    sliders.forEach((slider) => {
        if (isMobile) {
            destroySlider(slider);
            return;
        }

        if (!slider.swiper) {
            initSlider(slider);
        }
    });
};

export const initAdvantagesPageSliderSection = () => {
    const sliders = Array.from(document.querySelectorAll('[data-advantages-slider]'));
    const mobileMediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
    const handleBreakpointChange = () => syncSliders(sliders, mobileMediaQuery.matches);

    handleBreakpointChange();

    if (typeof mobileMediaQuery.addEventListener === 'function') {
        mobileMediaQuery.addEventListener('change', handleBreakpointChange);
        return;
    }

    mobileMediaQuery.addListener(handleBreakpointChange);
};
